// extracted by mini-css-extract-plugin
export var attachment = "_nj-a";
export var emailContainer = "_nj-4";
export var emailContentPaddedContainer = "_nj-b";
export var emailHeader = "_nj-6";
export var emailIframe = "_nj-3";
export var emailInfoIcon = "_nj-9";
export var emailShortenedSummary = "_nj-e";
export var infoDropdown = "_nj-0";
export var infoRowBoundedContent = "_nj-d";
export var internal = "_nj-5";
export var merchant = "_nj-8";
export var messageInputContainer = "_nj-h";
export var normal = "_nj-7";
export var replyCard = "_nj-f";
export var subtleButton = "_nj-1";
export var subtleButtonIconContainer = "_nj-2";
export var toggleViewRepliesButton = "_nj-c";
export var wrappingText = "_nj-g";